// Canonical school list for Eduspace. Bookings carry a school either as the FK
// below (`school_id`) or as the free-text label the older forms sent, so every
// consumer normalises through `canonicalSchoolId` before keying off it.
export const SCHOOL_OPTIONS = [
    { name: "TETR", type: "school", value: "8909170a-95b5-40bc-80d6-222078da5tet" },
    { name: "UG", type: "school", value: "8909170a-95b5-40bc-80d6-222078da5ug" },
    { name: "PGP", type: "school", value: "8909170a-65b5-40bc-80d6-222078da5pgp" },
    { name: "EXECUTIVE EDUCATION", type: "school", value: "8909170a-65b5-40bc-80d6-222078da5dec" },
    { name: "CENTRAL FUNCTIONS", type: "school", value: "8909170a-95b5-40bc-80d6-222078da5cf" },
];

// ---- School colours ----------------------------------------------------
// A school's colour is admin-editable and lives in the SAME table as the
// per-booking colour types (`getAllBookingColorTypes`), so no new endpoint is
// needed. A row belongs to a school when it carries a `school_id` — and until
// the API grows that column, when its `name` uses the "school:<id>" convention.
// Reading prefers the real column, so adding it server-side is a drop-in
// upgrade with no frontend change. School rows are filtered out of the
// per-booking type picker; they only drive the calendar's school colouring.
export const SCHOOL_COLOR_PREFIX = "school:";

export const schoolColorTypeName = (schoolId) => `${SCHOOL_COLOR_PREFIX}${schoolId}`;

export const schoolIdOfColorType = (t) => {
    if (!t) return null;
    if (t.school_id) return String(t.school_id);
    const name = typeof t.name === "string" ? t.name : "";
    return name.startsWith(SCHOOL_COLOR_PREFIX)
        ? name.slice(SCHOOL_COLOR_PREFIX.length) || null
        : null;
};

export const isSchoolColorType = (t) => !!schoolIdOfColorType(t);

// Any school reference (FK, display name, or an unknown free-text value) → the
// one key everything else hashes / looks up on.
export const canonicalSchoolId = (raw) => {
    if (raw == null || raw === "") return "—";
    const val = String(raw).trim();
    const byId = SCHOOL_OPTIONS.find((s) => s.value === val);
    if (byId) return byId.value;
    const byName = SCHOOL_OPTIONS.find(
        (s) => s.name.toLowerCase() === val.toLowerCase()
    );
    return byName ? byName.value : val;
};

export const schoolNameForId = (id) =>
    SCHOOL_OPTIONS.find((s) => s.value === canonicalSchoolId(id))?.name || null;

// Split a colour-type list into the per-booking types (shown in the pickers)
// and the school rows (which drive school colouring).
export const splitColorTypes = (colorTypes = []) => {
    const bookingTypes = [];
    const schoolTypes = [];
    (colorTypes || []).forEach((t) => (isSchoolColorType(t) ? schoolTypes : bookingTypes).push(t));
    return { bookingTypes, schoolTypes };
};

// schoolId → hex, for the calendar. Last row wins if a school was saved twice.
export const schoolColorMapOf = (colorTypes = []) => {
    const map = {};
    (colorTypes || []).forEach((t) => {
        const id = schoolIdOfColorType(t);
        if (id && t.color) map[canonicalSchoolId(id)] = t.color;
    });
    return map;
};

// schoolId → the colour-type row backing it, so an edit updates instead of
// inserting a duplicate.
export const schoolColorRowsOf = (colorTypes = []) => {
    const map = {};
    (colorTypes || []).forEach((t) => {
        const id = schoolIdOfColorType(t);
        if (id) map[canonicalSchoolId(id)] = t;
    });
    return map;
};
